import {Component, Input, OnInit} from "@angular/core";

@Component({
    selector: "fui-chrome-control",
    templateUrl: "./chrome-control.component.html",
    styleUrls: ["./chrome-control.component.scss"]
})
export class FUIChromeControlComponent implements OnInit {
    public id: number;
    public conflict: boolean;
    public active: boolean;
    @Input() title: string;

    constructor() {

    }

    ngOnInit() {

    }
}
